import { composeStore, isFullComposeShown } from 'mini-mail-compose-store';
import { HARD_BACK_BUTTON_CLICKED } from 'mini-mail-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { logUsage } from 'owa-analytics';
import { signalWorkflowEvent } from 'mini-workflow-manager';
import {
    lazyDeleteComposeDraft,
    lazyHandleComposeClose,
    lazyLoadDraftToCompose,
    lazyNewMessage,
} from 'mini-mail-compose-actions-mail';

export interface MailComposeRouteParameters {
    draftId: string;
}

/**
 *  Handle view state creation task for compose.
 */
export async function composeRouterHandler(params: MailComposeRouteParameters) {
    if (isFullComposeShown()) {
        // If compose viewState is available, load the compose from viewState.
        return;
    } else if (params.draftId) {
        // on compose draft message
        await lazyLoadDraftToCompose(params.draftId);
    } else {
        (await lazyNewMessage.import())();
    }
}

/**
 *  Handle cleanup task for compose.
 */
export async function composeCleanupRouteHandler(
    oldRoute: string[] | undefined,
    oldParameters: unknown,
    newRoute: string[]
): Promise<boolean> {
    // Special handling when user is going back from 'compose/:draftId' to 'compose' route,
    if (newRoute.includes('compose')) {
        history.back();
        return false;
    }

    logUsage(HARD_BACK_BUTTON_CLICKED, ['Compose_View']);
    signalWorkflowEvent(HARD_BACK_BUTTON_CLICKED);

    // If state is dirty, context menu is used to get the confirmation from user.
    const customComposeDraftDelete = async (
        itemId: string,
        onSuccess: () => void,
        onError: (error: Error) => void
    ) => {
        (await lazyDeleteComposeDraft.import())(itemId, undefined, onSuccess, onError);
    };
    const viewState = composeStore.defaultViewState;
    (await lazyHandleComposeClose.import())(viewState, customComposeDraftDelete);

    return false;
}
